// extracted by mini-css-extract-plugin
export default {"melodyVideo":"XL-z","isFullWidth":"YL-z","landingPageVideo":"ZL-z","play":"_L-z","iframeVideo":"aM-z","playHidden":"bM-z","fullwidth":"cM-z"};